import React from 'react'
import Video from '@/components/video/Video'
import { MainColumn, MainColumnLeft, MainColumnRight } from '../main-column/MainColumn'

type VideoAndTextProps = {
  video: string

  heading?: string
  title?: string
  titleTag?: string
  titleClass?: string
  text?: string
  button?: {
    title: string
    url: string
    target?: string
  }
}

/*
  Note: loading="lazy" is added via `modify-oembed-atts.php`
  TODO: review if this is the best approach or if a custom lazy loading solution should be implemented
*/

// TODO: migration script for video content? Merge video and video_and_text?
// TODO: how to handle dnt parameter?
export default function VideoAndText({
  video,
  heading = null,
  title = null,
  titleTag = 'h2',
  titleClass = 'h2',
  text = null,
  button = null,
}: VideoAndTextProps) {
  const hasText = heading || title || text

  // Gracefully handle situations where no text was provided
  if (!hasText) {
    return <Video video={video} />
  }

  return (
    <div className="component component--video">
      <MainColumn>
        <MainColumnLeft
          heading={heading}
          title={title}
          titleTag={titleTag}
          titleClass={titleClass}
          text={text}
          button={button}
        />

        <MainColumnRight>
          <div
            className="mx-auto aspect-[16/9] overflow-hidden rounded-lg"
            dangerouslySetInnerHTML={{ __html: video }}></div>
        </MainColumnRight>
      </MainColumn>
    </div>
  )
}
